import { ILocalStore } from '@/stores/interfaces/ILocalStore';
import { DocumentsTreeSelectionStore } from '@/stores/local/shared/DocumentsTreeSelectionStore/DocumentsTreeSelectionStore';
import { PopupStore } from '@/stores/local/shared/PopupStore';
import { TreeStore } from '@/stores/local/shared/TreeStore';

import { CreateFolderPopupStore } from './CreateFolderPopupStore';
import { DeleteFolderPopupStore } from './DeleteFolderPopupStore';
import { UploadDocumentPopupStore } from './UploadDocumentPopupStore';

type PopupsStoreParams = {
  getOrganizationId: () => number;
  getOrganizationName: () => string | null;
  treeStore: TreeStore;
  selectionStore: DocumentsTreeSelectionStore;
};

export class PopupsStore implements ILocalStore {
  readonly uploadDocumentPopup: UploadDocumentPopupStore;
  readonly deleteDocumentPopup = new PopupStore<string>();

  readonly createFolderPopup: CreateFolderPopupStore;
  readonly deleteFolderPopup: DeleteFolderPopupStore;

  constructor({ getOrganizationId, getOrganizationName, treeStore, selectionStore }: PopupsStoreParams) {
    this.uploadDocumentPopup = new UploadDocumentPopupStore({
      getOrganizationId,
      getOrganizationName,
      treeStore,
      selectionStore,
    });

    this.createFolderPopup = new CreateFolderPopupStore({ getOrganizationId, treeStore, selectionStore });
    this.deleteFolderPopup = new DeleteFolderPopupStore({ getOrganizationId, treeStore });
  }

  changeOrganizationId(): void {
    this.deleteDocumentPopup.close();
    this.deleteDocumentPopup.entity = null;
    this.uploadDocumentPopup.changeOrganizationId();
    this.createFolderPopup.changeOrganizationId();
    this.deleteFolderPopup.changeOrganizationId();
  }

  destroy() {
    this.uploadDocumentPopup.destroy();
    this.deleteDocumentPopup.destroy();
    this.createFolderPopup.destroy();
    this.deleteFolderPopup.destroy();
  }
}
